<div *ngIf="content$ | async as content" class="nordic-blue-900-bg white-text ps-xlarge">
  <div class="grid-max-width grid-col-12">
    <div [class]="content.gridClass || 'col-1-12 md-col-2-11'">
      <h3 class="white-text">
        {{ content.title || content.teaserTitle }}
      </h3>
      <div class="flex column-wrapper">
        <div *ngFor="let column of content.items" class="flex-1 flex--basis0" data-test-article>
          <cms-rich-text [content$]="column | finToObservable"> </cms-rich-text>
          <div *ngFor="let link of column.related" class="flex nowrap">
            <cms-text-link [content$]="link | finToObservable" [colorClass]="'white-text'"></cms-text-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
